import { Popconfirm as AntPopconfirm, PopconfirmProps } from 'antd';

import React from 'react';
import cn from 'classnames';

import styles from './Popconfirm.module.scss';

export interface IPopconfirmProps extends PopconfirmProps {}

/**
 * Popconfirm component
 */
export const Popconfirm: React.FC<IPopconfirmProps> = ({
  className,
  ...restProps
}) => {
  return (
    <AntPopconfirm
      overlayClassName={cn(styles.Popconfirm, className)}
      {...restProps}
    />
  );
};
